import axios from 'axios'
import { token } from '../services/auth-header'

const IDENTITY_VERIFICATION_URL = 'identity-verification/'

const authConfig = () => {
  return {
    headers: {
      Authorization: `Token ${token()}`
    },
    skipAuthRedirect: true
  }
}

const getIdentityVerification = async () => {
  return await axios
    .get(IDENTITY_VERIFICATION_URL, authConfig())
    .then(response => response.data)
}

const startIdentityVerification = async (action = 'start') => {
  return await axios
    .post(IDENTITY_VERIFICATION_URL, { action }, authConfig())
    .then(response => response.data)
}

export {
  getIdentityVerification,
  startIdentityVerification
}
